import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { RESIZER_POSITIONS } from './constants';

const propTypes = {
  position: PropTypes.oneOf(Object.values(RESIZER_POSITIONS)).isRequired,
  onMouseDown: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const CardDesignerCardElementResizeResizer = ({
  position,
  onMouseDown,
  className,
}) => {
  const classes = classNames({
    'card-designer-card-element-resize-resizer': true,
    [`resizer-${position.toLowerCase()}`]: true,
    [className]: !!className,
  });

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Resize"
      className={classes}
      onMouseDown={onMouseDown}
    />
  );
};

CardDesignerCardElementResizeResizer.propTypes = propTypes;

export default CardDesignerCardElementResizeResizer;
